export enum Topic {
	society = "society",
	environment_animals = "environment_animals",
	research_knowledge = "research_knowledge",
	urgency_oneshot = "urgency_oneshot"
}